module.exports = __webpack_public_path__ + "static/media/TvShowBanner (16).9d995724.png";